import React, { useState, useRef } from 'react';
import { motion, useSpring, useMotionValue } from 'framer-motion';
import { useCopy } from './copy/copyMode';
const FOUNDER_PHOTO_URL = 'https://cdn.magicpatterns.com/uploads/17254cM6qXXJBjqAfHJEz5/image_14.png';
export function NarrativeSection() {
  const copy = useCopy();
  const sectionRef = useRef<HTMLElement>(null);
  const [isHovered, setIsHovered] = useState(false);
  // Mouse tracking for custom cursor
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);
  // Smooth spring physics for the cursor to give it a slight "multiplayer" floaty feel
  const springX = useSpring(mouseX, {
    stiffness: 800,
    damping: 35,
    mass: 0.5
  });
  const springY = useSpring(mouseY, {
    stiffness: 800,
    damping: 35,
    mass: 0.5
  });
  const handleMouseMove = (e: React.MouseEvent) => {
    // Track mouse position relative to the viewport
    mouseX.set(e.clientX);
    mouseY.set(e.clientY);
  };
  return <section ref={sectionRef} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onMouseMove={handleMouseMove} className="relative w-full bg-[#FAF8F4] py-16 md:py-48 overflow-hidden cursor-none border-y border-neutral-200/70" data-id="element-1533">
      {/* Visible Dot Matrix Background */}
      <div className="absolute inset-0 dot-matrix opacity-40 pointer-events-none" data-id="element-1534" />

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10 flex flex-col items-center justify-center" data-id="element-1535">
        {/* Display Quote */}
        <h2 className="text-2xl md:text-5xl lg:text-6xl font-title font-medium text-[#2B211A] tracking-tight leading-[1.3] md:leading-[1.15] text-center max-w-5xl mx-auto mb-10 md:mb-14" data-id="element-1536">
          {copy.narrativeSection.quote}
        </h2>

        {/* Signature — on mobile (no hover, so the cursor-follow head never shows)
            we pin a small Tony head beside the line as a static signature with a
            gentle idle float. Desktop keeps the text-only signature + cursor head. */}
        <div className="flex items-center justify-center gap-3" data-id="element-1537">
          <motion.img src={FOUNDER_PHOTO_URL} alt="" aria-hidden="true" className="md:hidden w-16 h-16 object-contain object-top drop-shadow-[0_4px_10px_rgba(0,0,0,0.18)] shrink-0" animate={{
          y: [0, -4, 0]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-1538" />
          <span className="text-sm md:text-base font-mono font-medium tracking-tight text-neutral-400 text-center" data-id="element-1539">
            Hey, it's Tony 👋
          </span>
        </div>
      </div>

      {/* Custom Founder Cursor — desktop only (mobile uses the static signature above) */}
      <motion.div className="hidden md:flex fixed top-0 left-0 z-50 pointer-events-none items-center justify-center" style={{
      x: springX,
      y: springY,
      opacity: isHovered ? 1 : 0,
      scale: isHovered ? 1 : 0.5
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} data-id="element-1540">
        {/* The cursor head — free-floating cut-out, no circle frame */}
        <div className="relative w-16 h-16 md:w-20 md:h-20 -ml-8 -mt-8 md:-ml-10 md:-mt-10" data-id="element-1541">
          <img src={FOUNDER_PHOTO_URL} alt="" aria-hidden="true" className="w-full h-full object-contain object-top drop-shadow-[0_6px_14px_rgba(0,0,0,0.18)]" data-id="element-1542" />
        </div>
      </motion.div>
    </section>;
}